module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAOVBMVEVHcEz///////////////////////////////////////////////////////////////////////99PJZNAAAAE3RSTlMADCjJNd7s+uMhAxp7Sq0+W2uTiK76kgAAAJhJREFUKM+Nk8kOBCEIRGUQaHHt+f+PHS8unY5kypO+iFqUTmth2cSlqhuqKHxtYkE/YRFsflND+cKAzHmV6dLMGMdEKLiHAq2VF4xo7ISc4Qj7sQ7gCF1MKR6hJ05wgpD4uuEAJ51Qw2epFqEGCwZcBhP1ZlB+QBrjBc2y5oX+fYppgmGfGsar1TKz2XtMzICZ0TRDbX2HH2guCbc6R0imAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_logout1.png
// module id = cfRj
// module chunks = 2